import PropTypes from "prop-types";
import clsx from "clsx";

// Components
import MatchList from "./MatchList";

// MUI
import { Grid, Typography, Stack } from "@mui/material";

export default function MatchesItem(props) {
	const { title, matches = { partialMatchList: [], fullMatchList: [] }, loading, selected, additional, disabled } = props;
	return (
		<Grid container direction="row">
			<Grid item xs={12}>
				<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
					<Stack sx={{ minWidth: 0 }}>
						<Typography
							className={clsx({
								"!py-[1px] !pr-[2px] !font-sans !text-default": true,
								"!text-default": !selected,
								"!text-white": selected,
								"!text-neutral-gray": disabled,
							})}
							fontSize={"14.5px"}
							noWrap
						>
							{title}
						</Typography>
					</Stack>
					<Stack
						direction={"row"}
						alignContent={"center"}
						justifyContent={"flex-end"}
						ml={"5px"}
						spacing={0.5}
						sx={{ flexGrow: 1, minHeight: "24px" }}
					>
						{additional}
						<MatchList matches={matches} label={title} isSelected={selected} loading={loading} />
					</Stack>
				</Stack>
			</Grid>
		</Grid>
	);
}

MatchesItem.propTypes = {
	title: PropTypes.string,
	loading: PropTypes.bool,
	selected: PropTypes.bool,
	additional: PropTypes.node,
	disabled: PropTypes.bool,
	matches: PropTypes.shape({
		partialMatchList: PropTypes.arrayOf(PropTypes.string),
		fullMatchList: PropTypes.arrayOf(PropTypes.string),
	}),
};
